// extracted by mini-css-extract-plugin
module.exports = {"header":"Lq75tV3L","collapsed":"j7uqqB4k","divider":"DFjtf89f","logo":"PC9KdmTa"};